/* ==========================================================================
   Acadiana Made — back-in-stock.js
   Notify-me panel on the PDP (snippets/back-in-stock.liquid).
   Listens on document for the bubbling 'variant:change' CustomEvent that
   sections/main-product.liquid dispatches on [data-variant-select] with
   detail.variant ({ id, title, available, options[] }) and:
     - shows the panel when the selected variant is unavailable, hides it
       when it is available;
     - keeps the hidden contact[product-variant] / contact[product-url]
       fields and the visible "for: Black / M" line in sync.
   Initial state comes from the server-rendered data-available / data-open
   attributes (the initial variant:change fires from an inline script before
   this deferred file runs, so it cannot be relied on).
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = '[data-back-in-stock]';

  function variantTitle(variant) {
    if (!variant) return '';
    if (variant.title && variant.title !== 'Default Title') return variant.title;
    if (variant.options && variant.options.length) return variant.options.join(' / ');
    return '';
  }

  function apply(panel, variant) {
    if (!panel || !variant) return;
    var available = !!variant.available;
    panel.hidden = available;
    panel.setAttribute('data-available', available ? 'true' : 'false');

    var single = panel.hasAttribute('data-single-variant');
    var title = single ? '' : variantTitle(variant);

    var label = panel.querySelector('[data-bis-variant-label]');
    var forLine = panel.querySelector('[data-bis-for]');
    if (label) label.textContent = title;
    if (forLine) forLine.hidden = !title;

    var variantField = panel.querySelector('[data-bis-variant-field]');
    if (variantField) variantField.value = title;

    var urlField = panel.querySelector('[data-bis-url-field]');
    var base = panel.getAttribute('data-product-url');
    if (urlField && base && variant.id) urlField.value = base + '?variant=' + variant.id;
  }

  function panelFor(target) {
    var root = target && target.closest ? target.closest('.pdp') : null;
    return (root && root.querySelector(SELECTOR)) || document.querySelector(SELECTOR);
  }

  function init() {
    var panels = document.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(panels, function (panel) {
      // data-open = Shopify redirected back with a success/error state for
      // this form; keep it visible even if the selected variant is in stock.
      if (panel.hasAttribute('data-open')) { panel.hidden = false; return; }
      panel.hidden = panel.getAttribute('data-available') === 'true';
    });
  }

  document.addEventListener('variant:change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    apply(panelFor(e.target), variant);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
